import '@pexip/components/src/fonts.css';
import '@pexip/components/dist/components.css';
import '@pexip/media-components/dist/media-components.css';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {ErrorBoundary} from '@sentry/react';

import './polyfills';

import {ALLOWED_LANGUAGES, initI18next} from './i18n';
import {initialLog} from './initialLog';
import {logger} from './logger';
import {config} from './config';
import {router} from './router';
import {setupSentry} from './sentry';
import {App} from './App';
import {Error} from './pages/Error.page';
import {applicationConfig} from './applicationConfig';

const _createElement = React.createElement;

type CreateElement = typeof _createElement;

React.createElement = ((...args: Parameters<typeof _createElement>) => {
    const props = args[1] as
        | (React.Attributes & {'data-testid'?: string})
        | null
        | undefined;
    const testId = props?.['data-testid'];

    if (testId && applicationConfig.hiddenFunctionality[testId]) {
        return _createElement(React.Fragment, null);
    }
    return _createElement(...args);
}) as CreateElement;

initialLog();
setupSentry();
void initI18next(ALLOWED_LANGUAGES);

router.urlChangedSignal.add(url => {
    logger.debug({url}, 'Url changed');
});
router.urlRequestSignal.add(url => {
    logger.debug({url}, 'request a new Url');
});

// loadConfigFromQuery is off for security reasons:
const loadConfigFromQuery = false;
config.load({}, loadConfigFromQuery);

// getElementById can be potentially null, but not worth handling, too broken if it is
const root = createRoot(document.getElementById('root') as HTMLDivElement);

root.render(
    <ErrorBoundary
        fallback={({resetError: reload}) => <Error reload={reload} />}
    >
        <App />
    </ErrorBoundary>,
);
